<ng-template appDynamicColumn></ng-template>
